/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useStoreActions, useStoreState } from '../../reducers';

// This function retrieves the stored search query for a given organization ID from localStorage and constructs the appropriate path for the private drive. If no search query is found, it defaults to '/drive/private'.
const getPrivateDrivePath = (orgId: number) => {
  const storedSearch = localStorage.getItem(`search_${orgId}`);

  if (!storedSearch) {
    return '/drive/private';
  }

  // Ensure search always starts with '?' when read from storage.
  const normalizedSearch = storedSearch.startsWith('?')
    ? storedSearch
    : `?${storedSearch}`;

  return `/drive/private${normalizedSearch}`;
};

/**
 *
 */
export default function DriveListPage() {
  /* 
    call getOrgRecordingNum to know whether the organization has private uploaded recording
    if the count > 0, user will be sent to recording page to start with their own recordings
    otherwise, user will go to public data page to view the recording provided by ouster
  */
  const { getOrgRecordingNum } = useStoreActions((actions) => actions.drive);
  const { curUserOrg } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const [orgRecordingNum, setOrgRecordingNum] = useState<null | number>(null);

  useEffect(() => {
    const getRecordingCount = async () => {
      if (!curUserOrg?.id) return;
      try {
        const data = await getOrgRecordingNum({ orgId: curUserOrg?.id });
        setOrgRecordingNum(data.count);
      } catch (error) {
        setOrgRecordingNum(0);
      }
    };

    getRecordingCount();
  }, [curUserOrg?.id, getOrgRecordingNum]);

  if (orgRecordingNum === null) return null;

  const privateDrivePath = curUserOrg?.id
    ? getPrivateDrivePath(curUserOrg.id)
    : '/drive/private';

  return (
    <div>
      {orgRecordingNum > 0 ? (
        <Navigate to={privateDrivePath} replace />
      ) : (
        <Navigate to="/drive/sample_library" replace />
      )}
    </div>
  );
}
